var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _circle4, _circle5, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 58,
    viewBox: "0 0 145 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1378 27H62.9055V22.7557H65.2322C68.2429 22.7557 69.9943 20.9595 69.9943 18.3452C69.9943 15.7436 68.2749 13.9091 65.3026 13.9091H60.1378V27ZM62.9055 20.5376V16.1719H64.772C66.37 16.1719 67.1435 17.0412 67.1435 18.3452C67.1435 19.6428 66.37 20.5376 64.7848 20.5376H62.9055ZM71.7921 27H74.5598V22.3594H76.5797L79.0598 27H82.1152L79.3347 21.9119C80.824 21.2727 81.6486 19.9751 81.6486 18.1854C81.6486 15.5838 79.9292 13.9091 76.9569 13.9091H71.7921V27ZM74.5598 20.1349V16.1719H76.4263C78.0243 16.1719 78.7978 16.8814 78.7978 18.1854C78.7978 19.483 78.0243 20.1349 76.4391 20.1349H74.5598ZM95.6344 20.4545C95.6344 16.1719 92.9753 13.7301 89.5044 13.7301C86.0144 13.7301 83.3745 16.1719 83.3745 20.4545C83.3745 24.718 86.0144 27.179 89.5044 27.179C92.9753 27.179 95.6344 24.7372 95.6344 20.4545ZM92.8283 20.4545C92.8283 23.2287 91.5115 24.7308 89.5044 24.7308C87.4909 24.7308 86.1806 23.2287 86.1806 20.4545C86.1806 17.6804 87.4909 16.1783 89.5044 16.1783C91.5115 16.1783 92.8283 17.6804 92.8283 20.4545ZM104.786 17.674H107.439C107.401 15.3409 105.483 13.7301 102.568 13.7301C99.6982 13.7301 97.5952 15.3153 97.608 17.6932C97.6016 19.6236 98.9631 20.7294 101.175 21.2599L102.6 21.6179C104.026 21.9631 104.818 22.3722 104.825 23.2543C104.818 24.2131 103.911 24.8651 102.504 24.8651C101.066 24.8651 100.031 24.2003 99.9411 22.8899H97.2628C97.3331 25.7216 99.3594 27.1854 102.536 27.1854C105.732 27.1854 107.612 25.6577 107.618 23.2607C107.612 21.081 105.969 19.924 103.693 19.4126L102.517 19.1314C101.379 18.8693 100.427 18.4474 100.446 17.5078C100.446 16.6641 101.194 16.044 102.549 16.044C103.872 16.044 104.684 16.6449 104.786 17.674ZM109.48 27H112.247V22.7557H114.574C117.585 22.7557 119.336 20.9595 119.336 18.3452C119.336 15.7436 117.617 13.9091 114.644 13.9091H109.48V27ZM112.247 20.5376V16.1719H114.114C115.712 16.1719 116.485 17.0412 116.485 18.3452C116.485 19.6428 115.712 20.5376 114.127 20.5376H112.247ZM121.134 27H129.98V24.718H123.902V21.5923H129.501V19.3104H123.902V16.1911H129.955V13.9091H121.134V27ZM143.706 18.4922C143.341 15.4688 141.053 13.7301 138.023 13.7301C134.565 13.7301 131.925 16.1719 131.925 20.4545C131.925 24.7244 134.52 27.179 138.023 27.179C141.379 27.179 143.405 24.9482 143.706 22.5384L140.906 22.5256C140.644 23.9254 139.545 24.7308 138.068 24.7308C136.08 24.7308 134.731 23.2543 134.731 20.4545C134.731 17.7315 136.061 16.1783 138.087 16.1783C139.602 16.1783 140.695 17.054 140.906 18.4922H143.706Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9055 30.9091H60.1378V44H62.9055V30.9091ZM65.1827 30.9091V44H67.8674V35.4474H67.976L71.3638 43.9361H73.1919L76.5797 35.4794H76.6884V44H79.373V30.9091H75.9597L72.3546 39.7045H72.2012L68.5961 30.9091H65.1827ZM81.6534 30.9091V44H84.3381V35.4474H84.4467L87.8345 43.9361H89.6626L93.0504 35.4794H93.1591V44H95.8438V30.9091H92.4304L88.8253 39.7045H88.6719L85.0668 30.9091H81.6534ZM110.154 37.4545C110.154 33.1719 107.495 30.7301 104.024 30.7301C100.534 30.7301 97.894 33.1719 97.894 37.4545C97.894 41.718 100.534 44.179 104.024 44.179C107.495 44.179 110.154 41.7372 110.154 37.4545ZM107.348 37.4545C107.348 40.2287 106.031 41.7308 104.024 41.7308C102.01 41.7308 100.7 40.2287 100.7 37.4545C100.7 34.6804 102.01 33.1783 104.024 33.1783C106.031 33.1783 107.348 34.6804 107.348 37.4545Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 38,
    r: 3,
    fill: "#5C2670"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 127,
    cy: 38,
    r: 3,
    fill: "#5C2670"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 135,
    cy: 38,
    r: 3,
    fill: "#5C2670"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 16L25.5 3L3 16V42L25.5 55L48 42V16Z",
    stroke: "#812DA0",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 16L25.5 3L3 16V42L25.5 55L48 42V16Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 29.5,
    r: 4.5,
    fill: "#812DA0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 29.5,
    r: 4.5,
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 7.5V22.5C29.1 22.5 30.3333 24.5 30.5 25.5L44.5 18L25.5 7.5Z",
    fill: "#812DA0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 7.5V22.5C29.1 22.5 30.3333 24.5 30.5 25.5L44.5 18L25.5 7.5Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.5,
    y1: 3,
    x2: 25.5,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39CCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 25.5,
    y1: 25,
    x2: 25.5,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39CCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 33.5,
    y1: 14.5,
    x2: 20.5,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.fe5f236ef64faf25cdc71e59d7c963b2.svg";
export { ForwardRef as ReactComponent };